import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
// hooks
import { useAuth } from 'src/hooks/auth/useAuth';
// components
import LoadingBar from '../components/Reusable/LoadingBar';
import { PATH_ROOT, PATH_AUTH } from '../routes/paths';
import { UserAccountState } from 'src/enums/shared.enums';

// ----------------------------------------------------------------------

type GuestGuardProps = {
    children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
    const { isAuthenticated, isInitialized, profile } = useAuth();

    if (isAuthenticated) {
        // Check if user needs to complete onboarding
        if (profile && profile.state === UserAccountState.PENDING) {
            return <Navigate to={PATH_AUTH.onboarding} />;
        }
        return <Navigate to={PATH_ROOT.organization.organizations} />;
    }

    if (!isInitialized) {
        return (
            <Box 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    minHeight: '100vh',
                    bgcolor: 'background.default'
                }}
            >
                <LoadingBar />
            </Box>
        );
    }

    return <>{children}</>;
}
